import * as React from "react";
import { Query, graphql } from "react-apollo";
import { Row, Col, Button } from "reactstrap";
import * as uuid from "uuid";
import { MdModeEdit, MdDeleteForever } from "react-icons/md";

// GraphQL
import GetCompanyWorkOrders from "../../GraphQL/Queries/GetCompanyWorkOrders";
import DeleteWorkOrder from "../../GraphQL/Mutations/DeleteWorkOrder";

// Presentation/UI
import Loader from "../../Components/Loader/DotLoader";
import Table from "../../Components/Table";
import GlobalModal from "../../Components/GlobalModal";
import DialogModal from "../../Components/DialogModal";

import EditWorkOrderForm from "./EditWorkOrderForm";

// Utils
import { orderDatasetByDateDesc } from "../../Utils/Helpers";

interface IProps {
  companyId: string;
  toastManager: any;
  mutate: any;
}

class AllWorkOrders extends React.Component<IProps> {
  state = {
    modal: false,
    dialogModal: false,
    loading: false,
    title: "Are you sure you want to delete this work order?",
    workOrder: {},
    workOrderId: null
  };

  // Close dialog modal
  closeDialogModal = (): void => {
    this.setState({
      dialogModal: false
    });
  };

  // Open dialog modal
  openDialogModal = (workOrder: any): void => {
    const workOrderId = !workOrder ? null : workOrder.id;
    this.setState({
      dialogModal: true,
      workOrderId
    });
  };

  // Handle response
  handleResponse = (e: React.FormEvent<HTMLInputElement>): void => {
    e.preventDefault();
    this.setState({ loading: true });
    // delete site mutation
    const { companyId } = this.props;
    this.props
      .mutate({
        variables: {
          id: this.state.workOrderId
        },
        refetchQueries: [
          {
            query: GetCompanyWorkOrders,
            variables: { id: companyId }
          }
        ]
      })
      .then((res: any) => {
        this.setState({ loading: false, partId: null });
        this.closeDialogModal();
        this.toastNotification("Work order deleted successfully");
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  // Close modal
  closeModal = (): void => {
    this.setState({
      modal: false
    });
  };

  // Open modal
  openModal = (workOrder: object): void => {
    this.setState({
      modal: true,
      workOrder
    });
  };

  // Return status
  returnStatus = (word: string): string => {
    switch (word) {
      case "OPEN":
        return "Open";
      case "ON_HOLD":
        return "On Hold";
      case "IN_PROGRESS":
        return "In Progress";
      case "COMPLETE":
        return "Complete";
      default:
        return "None";
    }
  };

  // success notification
  toastNotification = (message: string) => {
    this.props.toastManager.add(message, {
      appearance: "success",
      autoDismiss: true
    });
  };

  render() {
    const { workOrder } = this.state;
    const { companyId } = this.props;
    return (
      <Query query={GetCompanyWorkOrders} variables={{ id: companyId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the work orders</div>;
          }

          let workOrders = data.allWorkOrders;
          workOrders = orderDatasetByDateDesc(workOrders);

          return (
            <Row>
              <GlobalModal
                toggleModal={this.closeModal}
                title="Edit Work Order"
                modalDisplay={
                  <EditWorkOrderForm
                    notification={this.toastNotification}
                    closeModal={this.closeModal}
                    workOrder={workOrder}
                    companyId={companyId}
                  />
                }
                modal={this.state.modal}
              />
              <DialogModal
                modal={this.state.dialogModal}
                title={this.state.title}
                loading={this.state.loading}
                toggleModal={this.closeDialogModal}
                handleResponse={this.handleResponse}
              />
              <Col xs={12} md={12} lg={12}>
                <Table
                  data={workOrders}
                  columns={[
                    {
                      Header: "Title",
                      accessor: "title",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Description",
                      accessor: "description",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Work Scheduled On",
                      accessor: "dueDate",
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "Status",
                      accessor: (companyWorkOrder: any) => {
                        return this.returnStatus(companyWorkOrder.status);
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "Site",
                      accessor: (companyWorkOrder: any) => {
                        return !companyWorkOrder.site
                          ? ""
                          : companyWorkOrder.site.name;
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "",
                      accessor: (companyWorkOrder: object) => {
                        return (
                          <Button
                            onClick={() => this.openModal(companyWorkOrder)}
                            className="icon-btn icon-edit-btn"
                          >
                            <MdModeEdit color="#fff" size="1.35em" />
                          </Button>
                        );
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "",
                      accessor: (companyWorkOrder: object) => {
                        return (
                          <Button
                            onClick={() =>
                              this.openDialogModal(companyWorkOrder)
                            }
                            className="icon-btn icon-delete-btn"
                          >
                            <MdDeleteForever color="#fff" size="1.35em" />
                          </Button>
                        );
                      },
                      sortable: false,
                      filterable: false
                    }
                  ]}
                  defaultPageSize={5}
                  showPaginationTop={false}
                  showPaginationBottom={true}
                />
              </Col>
            </Row>
          );
        }}
      </Query>
    );
  }
}

export default graphql<any, Response, any, any>(DeleteWorkOrder)(AllWorkOrders);



// WEBPACK FOOTER //
// ./src/Containers/WorkOrders/AllWorkOrders.tsx